const DEFAULT_ITEMS_REQUEST = 1000;

const initQueryParams = ({
  limitItemsRequest,
  pageSize,
  page,
  sort,
  sortBy,
  useEntities,
  entities,
  navFullIdField,
  AndQueryParams,
}) => {
  const limit = limitItemsRequest || pageSize || DEFAULT_ITEMS_REQUEST;
  const queryParams = {
    limit,
  };
  if (page) {
    queryParams.offset = limit * (page - 1);
  }

  if (sortBy && sortBy.length) {
    const orderByQuery = {};
    sortBy.forEach((attr, index) => {
      orderByQuery[attr] = sort.ASC[index] ? 'ASC' : 'DESC';
    });
    queryParams.q = {
      ...queryParams.q,
      $orderby: orderByQuery,
    };
  }

  if (useEntities && entities && entities.length > 0) {
    const entitiesFilters = entities.map((ent) => {
      return { [navFullIdField]: { $like: `${ent.nav_full_id}%` } };
    });

    AndQueryParams.push({ $or: entitiesFilters });
  }

  return queryParams;
};

const baseParams = ({ rootGetters, item }) => {
  return {
    ...item,
    group_id: rootGetters['global/groupId'],
  };
};

function makeList$instr(obj) {
  return Object.keys(obj)
    .filter((attribute) => obj[attribute] && obj[attribute].length)
    .map((attribute) => {
      return {
        [attribute]: { $instr: `${obj[attribute]}` },
      };
    });
}

function makeSearchQueryParams(search, AndQueryParams) {
  if (search) {
    if (search.$or) {
      const orSearchParams = makeList$instr(search.$or);
      if (orSearchParams.length > 0)
        AndQueryParams.push({ $or: orSearchParams });
    }
    if (search.$and) {
      const andSearchParams = makeList$instr(search.$and);
      if (andSearchParams.length > 0)
        AndQueryParams.push({ $and: andSearchParams });
    }
  }
}

function makeDatesQueryParams(
  dateField,
  dateNullable,
  dateMin,
  AndQueryParams,
  dateMax
) {
  if (dateField) {
    if (dateMin) {
      if (dateNullable) {
        AndQueryParams.push({
          $or: [
            {
              [dateField]: { $gte: { $date: new Date(dateMin).toISOString() } },
            },
            {
              [dateField]: { $null: 'null' },
            },
          ],
        });
      } else {
        AndQueryParams.push({
          [dateField]: { $gte: { $date: new Date(dateMin).toISOString() } },
        });
      }
    }
    if (dateMax) {
      if (dateNullable) {
        AndQueryParams.push({
          $or: [
            {
              [dateField]: { $lt: { $date: new Date(dateMax).toISOString() } },
            },
            {
              [dateField]: { $null: 'null' },
            },
          ],
        });
      } else {
        AndQueryParams.push({
          [dateField]: { $lt: { $date: new Date(dateMax).toISOString() } },
        });
      }
    }
  }
}

function makeQueryParam$eq(attributesObj, AndQueryParams) {
  return (attribute) => {
    const orFilters = attributesObj[attribute].values.map((val) => {
      return {
        [attribute]: { $eq: `${val}` },
      };
    });
    if (orFilters.length > 0) {
      AndQueryParams.push({
        $or: orFilters,
      });
    }
  };
}

function makeQueryParam$ne(attributesObj, AndQueryParams) {
  return (attribute) => {
    const orFilters = attributesObj[attribute].values.map((val) => {
      return {
        [attribute]: { $ne: `${val}` },
      };
    });
    if (orFilters.length > 0) {
      AndQueryParams.push({
        $or: orFilters,
      });
    }
  };
}

function makeQueryParam$instr(attributesObj, AndQueryParams, wrapper = '') {
  return (attribute) => {
    const orFilters = attributesObj[attribute].values.map((val) => {
      return {
        [attribute]: { $instr: `${wrapper}${val}${wrapper}` },
      };
    });
    if (orFilters.length > 0) {
      AndQueryParams.push({
        $or: orFilters,
      });
    }
  };
}

function makeQueryParam$date(attributesObj, AndQueryParams) {
  return (attribute) => {
    if (attributesObj[attribute].values.length === 2) {
      const dateFilters = [];

      if (attributesObj[attribute].values[0]) {
        dateFilters.push({
          [attribute]: {
            $gte: {
              $date: new Date(attributesObj[attribute].values[0]).toISOString(),
            },
          },
        });
      }

      if (attributesObj[attribute].values[1]) {
        dateFilters.push({
          [attribute]: {
            $lt: {
              $date: new Date(attributesObj[attribute].values[1]).toISOString(),
            },
          },
        });
      }
      if (dateFilters.length > 0) {
        AndQueryParams.push({
          $and: dateFilters,
        });
      }
    }
  };
}

function makeQueryParam$hasValue(attributesObj, AndQueryParams) {
  return (attribute) => {
    const orFilters = attributesObj[attribute].values.map((val) => {
      return {
        [val]: { $eq: 'O' },
      };
    });
    if (orFilters.length > 0) {
      AndQueryParams.push({
        $or: orFilters,
      });
    }
  };
}

function getAttributeList(attributesObj, type) {
  const res = [];
  Object.keys(attributesObj).forEach((key) => {
    if (attributesObj[key].serverSide) {
      if (attributesObj[key].type === type) {
        res.push(key);
      } else if (
        attributesObj[key].type &&
        attributesObj[key].type.startsWith('$is') &&
        type === '$is'
      ) {
        res.push({ attribute: key, value: attributesObj[key].type.slice(4) });
      } else if (!attributesObj[key].type && type === '$eq') {
        res.push(key);
      }
    }
  });
  return res;
}
function makeQueryParam$null(attributesObj, AndQueryParams) {
  return (attribute) => {
    const orFilters = attributesObj[attribute].values.map((val) => {
      if (val === 'O') {
        return {
          [attribute]: { $notnull: null },
        };
      }
      return {
        [attribute]: { $null: null },
      };
    });
    if (orFilters.length > 0) {
      AndQueryParams.push({
        $or: orFilters,
      });
    }
  };
}

function makeQueryParam$is(attributesObj, AndQueryParams) {
  return ({ attribute, value }) => {
    if (attributesObj[attribute].values.length === 1) {
      if (attributesObj[attribute].values[0]) {
        AndQueryParams.push({
          $or: [
            {
              [attribute]: { $instr: value },
            },
          ],
        });
      } else {
        AndQueryParams.push({
          $or: [
            {
              [attribute]: { $ninstr: value },
            },
          ],
        });
      }
    }
  };
}

export {
  makeDatesQueryParams,
  makeSearchQueryParams,
  makeQueryParam$eq,
  makeQueryParam$ne,
  makeQueryParam$instr,
  makeQueryParam$date,
  makeQueryParam$hasValue,
  initQueryParams,
  makeQueryParam$null,
  makeQueryParam$is,
  baseParams,
  getAttributeList,
  DEFAULT_ITEMS_REQUEST,
};
